const THREE = require('three')
import {loadingManager, load, registerSize} from '../loader'
import {maxAnisotropy} from '../renderer'
import {config as gameConfig} from '../config'


let base = require('src/../config').build.assetsPublicPath
let textureUrl = require('assets/models/sky/buildings.png')
registerSize(textureUrl, 80919)
let modelUrl = require('assets/models/sky/buildings.json')
registerSize(modelUrl, 2428)

import scene from '../scene'

// MESH
export let mesh = new THREE.Object3D()
mesh.name = 'buildings'
export default mesh
// scene.add(mesh)
mesh.scale.set(3, 1, 3)
mesh.scale.multiplyScalar(gameConfig.worldScale)

// MATERIAL
let material = new THREE.MeshBasicMaterial({
  fog: false,
  transparent: true
})

const textureLoader = new THREE.TextureLoader(loadingManager)
load(textureUrl, textureLoader, (results)=> {
  let texture = results[0]
  material.map = texture
  texture.anisotropy = maxAnisotropy
  texture.wrapS = texture.wrapT = THREE.RepeatWrapping
  material.needsUpdate = true
})


// MODEL
const modelLoader = new THREE.JSONLoader(loadingManager)
load(modelUrl, modelLoader, (results)=> {
  let geometry = results[0]
  geometry.computeFaceNormals()
  geometry.computeVertexNormals()
  let model = new THREE.Mesh(geometry, material)
  model.scale.setScalar(1)
  mesh.add(model)
})





// WEBPACK FOOTER //
// ./src/components/game/objects/buildings.js